<div class="component-container">
  <div class="component-header">
    <h2>Create New User</h2>
  </div>
  <app-user-form
    [form]="form"
    [isCreateMode]="true"
    submitButtonText="Create User"
    (submit)="onSubmit()"
    (cancel)="onCancel()">
  </app-user-form>
</div>
